import { render, staticRenderFns } from "./ddoCart.vue?vue&type=template&id=65458c66&"
import script from "./ddoCart.vue?vue&type=script&lang=js&"
export * from "./ddoCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports